import { BorderStyles } from '../../lib/types/StyleTypes';

const defBorderStyles: BorderStyles = {
  primary: '1px solid #979797',
  secondary: '1px solid #00BA99',
  tertiary: '1px solid #E9E9E9',
  error: '1px solid #FF0000',
  yellow: '1px solid #E8D069',
  grey: '1px solid #D6D7D6',
  darkBlue: '1px solid #466277',
  disabled: '',
};

export default defBorderStyles;
